import Registrations from "../components/pages/Registrations";

export default Registrations;
